<template>
<main class="content" v-bind:style="{paddingTop: HEADER_HEIGHT}">
  <span>Страница не найдена</span>
  <router-link :to=" { name: 'Home' } " class="button button_small">На главную</router-link>
</main>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'Page404',
  components: {
  },
  methods: {
  },
  computed: {
    ...mapGetters([
      'HEADER_HEIGHT',
      'HEADER_LANG'
    ])
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.content {
  background-color: #eee;
  text-align: center;
}
span {
  display: block;
  margin-top: 40px;
  font-size: 6rem;
  font-weight: 300;
  color: #000;
  margin-bottom: 20px;
}
a {
  display: inline-flex;
}
</style>
